// @flow
import {AUTH_ACTION_TYPE} from 'modules/auth/constants';
import type {TAuthUser, TAuthUserCompanyPayload, TAuthUserDataPayload} from 'modules/auth/types/user';
import {DATA_STATUSES, type TStatuses} from 'modules/redux/data-statuses';
import {createReducer} from 'modules/redux/reducer';

export type TActionLogInStart = {type: typeof AUTH_ACTION_TYPE.LOGIN_START};
export type TActionLogInFail = {type: typeof AUTH_ACTION_TYPE.LOGIN_FAIL};
export type TActionSetStatusEducation = {type: typeof AUTH_ACTION_TYPE.SET_STATUS_EDUCATION};
export type TActionLogInSuccess = {payload: TAuthUser, type: typeof AUTH_ACTION_TYPE.LOGIN_SUCCESS};
export type TSetAuthUserData = {payload: TAuthUserDataPayload, type: typeof AUTH_ACTION_TYPE.SET_AUTH_USER_DATA};
export type TSetAuthUserCompany = {payload: TAuthUserCompanyPayload, type: typeof AUTH_ACTION_TYPE.SET_AUTH_USER_COMPANY};
export type TActionLogOut = {type: typeof AUTH_ACTION_TYPE.LOGOUT};

export type TAuthState = {|
    status: TStatuses,
    user: TAuthUser,
|};

export const initialState: TAuthState = {
    status: DATA_STATUSES.UN_TOUCHED,
    user: {},
};

const reducer = {
    [AUTH_ACTION_TYPE.LOGIN_START]: (state) => ({
        ...state,
        status: DATA_STATUSES.LOADING,
    }),
    [AUTH_ACTION_TYPE.LOGIN_SUCCESS]: (state, payload: TAuthUser) => ({
        ...state,
        status: DATA_STATUSES.SUCCESS,
        user: payload,
    }),
    [AUTH_ACTION_TYPE.SET_AUTH_USER_DATA]: (state, payload: TAuthUserDataPayload) => ({
        ...state,
        user: {
            ...state.user,
            email: payload.email,
            firstName: payload.firstName,
            languageId: payload.languageId,
            newEmail: payload.newEmail,
        },
    }),
    [AUTH_ACTION_TYPE.SET_AUTH_USER_COMPANY]: (state, payload: TAuthUserCompanyPayload) => ({
        ...state,
        user: {
            ...state.user,
            companyName: payload.companyName,
        },
    }),
    [AUTH_ACTION_TYPE.LOGIN_FAIL]: (state) => ({
        ...state,
        status: DATA_STATUSES.ERROR,
    }),
    [AUTH_ACTION_TYPE.LOGOUT]: (state) => ({
        ...state,
        user: {},
    }),

    [AUTH_ACTION_TYPE.SET_STATUS_EDUCATION]: (state, payload) => ({
        ...state,
        user: {
            ...state.user,
            education: {
                ...payload,
            },
        },
    }),
};

export const authReducer = createReducer(initialState, reducer);
